import React from 'react';
import { Link } from 'react-router-dom';
import { SERVER_URL } from '../../utils/api';
import './ProductCard.css';

const ProductCard = ({ product, isWishlistMode = false, onRemoveFromWishlist = null, isRemoving = false }) => {
  const firstImage = product.images && product.images.length > 0 ? product.images[0] : null;
  const imageUrl = firstImage ? `${SERVER_URL}${firstImage}` : null;

  return (
    <div className="product-card card">
      <div className="product-image">
        {product.featured && <span className="product-badge">Destacado</span>}
        {/* <button
          className={`wishlist-btn ${isWishlistMode ? 'remove-mode' : ''} ${isInWishlist && !isWishlistMode ? 'active' : ''}`}
          onClick={toggleWishlist}
          disabled={isLoading || isRemoving}
          title={isWishlistMode ? 'Quitar de favoritos' : (isInWishlist ? 'Quitar de favoritos' : 'Agregar a favoritos')}
        >
          {isLoading || isRemoving ? (
            <span>⏳</span>
          ) : isWishlistMode ? (
            <span>🗑️</span>
          ) : (
            <span>{isInWishlist ? '❤️' : '🤍'}</span>
          )}
        </button> */}
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={product.name}
            className="product-image-img"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className="product-image-placeholder" style={imageUrl ? {display: 'none'} : {}}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5L11 16.51L14.5 12L19 18H5L8.5 13.5Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">
          {product.description.length > 80
            ? `${product.description.substring(0, 80)}...`
            : product.description}
        </p>
        <div className="product-footer">
          <div className="product-price-container">
            {product.discount > 0 ? (
              <>
                <span className="product-price-discounted">${product.finalPrice?.toFixed(2) || (product.price * (1 - product.discount / 100)).toFixed(2)}</span>
                <span className="product-price-original">${product.price.toFixed(2)}</span>
                <span className="product-discount-badge">-{product.discount}%</span>
              </>
            ) : (
          <span className="product-price">${product.price.toFixed(2)}</span>
            )}
          </div>
          <Link to={`/product/${product.id}`} className="btn btn-primary btn-sm">
            Ver Detalles
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
